import { ShieldAlert } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useRightSidebarEntity, useRightSidebarProject } from "../../contexts";
import { QualityGuardEntityPanel } from "../quality-guard/quality-guard-entity-state";

export function GuardianPanel() {
  const { projectId } = useRightSidebarProject();
  const { entityType, entityId, entityName, entityTabKey, entityFieldId } = useRightSidebarEntity();

  if (!entityType || !entityId) {
    return (
      <ScrollArea className="flex-1 px-4">
        <div className="py-4">
          <div className="rounded-md border border-dashed p-4 text-center text-muted-foreground">
            <ShieldAlert className="mx-auto mb-2 size-7" />
            <p className="text-sm font-medium">No entity selected</p>
            <p className="mt-1 text-xs">Open an entity to see Quality Guard findings.</p>
          </div>
        </div>
      </ScrollArea>
    );
  }

  return (
    <QualityGuardEntityPanel
      projectId={projectId}
      entityTypeKey={entityType}
      entityId={entityId}
      entityName={entityName}
      sectionTabKey={entityFieldId ? entityTabKey : null}
      sectionFieldId={entityFieldId}
    />
  );
}
